<template>
  <div class="BaseTemplateItemTransformSetting">
    <p class="fs-15px fw-500 text-cool-gray-80 q-mb-sm">{{ t('contents.styles.positions') }}</p>
    <div class="flex no-wrap items-center justify-between gap-xl">
      <div class="flex no-wrap items-center gap-sm">
        <span class="fw-500 fs-15px text-cool-gray-80">X</span>
        <k-input
          small
          root-class="BaseTemplateItemTransformSetting__input"
          :model-value="templateStore.activeItem.start_position.x"
          :has-clear-icon="false"
          input-class="text-center"
          @update:model-value="
            handleUpdateItem('start_position', {
              ...templateStore.activeItem.start_position,
              x: +$event,
            })
          "
        />
      </div>
      <div class="flex no-wrap items-center gap-sm">
        <span class="fw-500 fs-15px text-cool-gray-80">Y</span>
        <k-input
          small
          root-class="BaseTemplateItemTransformSetting__input"
          :model-value="templateStore.activeItem.start_position.y"
          :has-clear-icon="false"
          input-class="text-center"
          @update:model-value="
            handleUpdateItem('start_position', {
              ...templateStore.activeItem.start_position,
              y: +$event,
            })
          "
        />
      </div>
    </div>
    <div class="flex no-wrap items-center justify-between gap-sm q-mt-sm q-mb-md">
      <span class="fw-500 fs-15px text-cool-gray-80 flex-1">{{ t('contents.styles.rotate_degree') }}</span>
      <k-input
        small
        root-class="BaseTemplateItemTransformSetting__input"
        :model-value="templateStore.activeItem.rotate"
        :has-clear-icon="false"
        input-class="text-center"
        @update:model-value="templateStore.handleUpdateItemSetting('rotate', +$event)"
      />
    </div>

    <p class="fs-15px fw-500 text-cool-gray-80 q-mb-sm">{{ t('contents.styles.dimensions') }}</p>
    <div class="flex no-wrap items-center justify-between gap-xl">
      <div class="flex no-wrap items-center gap-sm">
        <span class="fw-500 fs-15px text-cool-gray-80">W</span>
        <k-input
          small
          root-class="BaseTemplateItemTransformSetting__input"
          :model-value="templateStore.activeItem.width"
          :has-clear-icon="false"
          input-class="text-center"
          @update:model-value="handleUpdateItem('width', +$event)"
        />
      </div>
      <div v-if="hasHeight" class="flex no-wrap items-center gap-sm">
        <span class="fw-500 fs-15px text-cool-gray-80">H</span>
        <k-input
          small
          root-class="BaseTemplateItemTransformSetting__input"
          :model-value="templateStore.activeItem.height"
          :has-clear-icon="false"
          input-class="text-center"
          @update:model-value="handleUpdateItem('height', +$event)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { useTemplateStore } from 'src/stores'
import translate from 'src/common/helpers/language/translate'
import translationObject from '../../translate/baseTemplate.translate'

defineOptions({ name: 'BaseTemplateItemTransformSetting' })
defineProps({ hasHeight: { type: Boolean, default: true } })

const templateStore = useTemplateStore()
const { t } = translate(translationObject)

function handleUpdateItem(field, value) {
  const { itemIndex } = templateStore.handleUpdateItemSetting(field, value)
  templateStore.handleItemPositionValidating({ itemIndex, layerIndex: templateStore.activeLayer.index })
}
</script>

<style lang="sass" scoped>
@import "src/shared/styles/mixins.sass"

.BaseTemplateItemTransformSetting
  @include element('input')
    width: 106px
</style>
